import {Component, OnInit} from '@angular/core';
import {AuthService} from "../service/auth.service";
import {AlertController, LoadingController, ModalController, ToastController} from "@ionic/angular";
import {UserEditPage} from "./user-edit/user-edit.page";
import {UserProfilesPage} from "./user-profiles/user-profiles.page";
import {SearchUtil} from "../shared/utils/SearchUtil";
import {UserAddPage} from "./user-add/user-add.page";

@Component({
  selector: 'app-users',
  templateUrl: './users.page.html',
  styleUrls: ['./users.page.scss'],
})
export class UsersPage implements OnInit {
  users: any[];
  usersFiltered: any;
  loading: any;

  constructor(private authService: AuthService,
              public loadingController: LoadingController,
              public alertController: AlertController,
              public toastController: ToastController,
              public modalController: ModalController) {
  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.getUsers();
  }

  async addUser() {
    const modal = await this.modalController.create({
      component: UserAddPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
    });

    return await modal.present();
  }

  async deleteUser(userId: number) {
    const alert = await this.alertController.create({
      header: 'Estas Seguro',
      message: 'Esta accion no se puede reversar',
      mode: 'ios',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
          },
        },
        {
          text: 'Eliminar',
          role: 'confirm',
          handler: () => {
            this.authService.deleteUser(userId).subscribe((response: any) => {
              this.presentToast('Usuario Eliminado Exitosamente');
              this.getUsers();
            }, error => {
              console.warn(error);
              this.presentToast(error.error.error);
            });
          },
        },
      ],
    });

    await alert.present();
  }

  onChangePage(event: any) {
    this.usersFiltered = event;
  }

  getUsers() {
    this.loading.present();
    this.authService.getAllUsers().subscribe((res: any[]) => {
      this.users = res;
      this.loading.dismiss();
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  async editUser(user: any) {
    const modal = await this.modalController.create({
      component: UserEditPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        user,
      }
    });
    modal.onDidDismiss().then(data => {
      if (data) {
        //this.loadData();
      }
    });
    return await modal.present();
  }


  async editProfiles(user: any) {
    const modal = await this.modalController.create({
      component: UserProfilesPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        user,
      }
    });
    modal.onDidDismiss().then(data => {
      if (data) {
        //this.loadData();
      }
    });
    return await modal.present();
  }

  search(event: any) {
    if (event && event.detail && event.detail.value) {
      const result = SearchUtil.findMatchingPositions(this.users, event.detail.value);
      this.usersFiltered = result;
    }
    if (event.detail.value === '') {
      this.usersFiltered = this.users;
    }
  }
}
